import React, { useEffect, useState } from "react";

import propTypes from "prop-types";

import "./styles.scss";

function stripHtml(html) {
  var temporalDivElement = document.createElement("div");
  temporalDivElement.innerHTML = /<body.*?>([\s\S]*)<\/body>/.exec(html)[1];
  return temporalDivElement.textContent || temporalDivElement.innerText || "";
}

const HtmlViewer = ({ url, ...props }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(url)
      .then((response) => response.text())
      .then((val) => {
        setData(stripHtml(val));
      })
      .catch(() => {});
  }, [url]);

  return (
    <div className={"documentation"} {...props}>
      <p>{data}</p>
    </div>
  );
};

HtmlViewer.propTypes = {
  url: propTypes.string.isRequired,
};

HtmlViewer.defaultProps = {};

export default HtmlViewer;
